import PlaceRating from "./PlaceRating";

export default PlaceRating;
